module.exports = __webpack_public_path__ + "img/orange-7.5736b30b.png";